export function trackEvent(eventData) {
  if (window.dataObject) {
    window.dataObject.time = Date()
    window.dataObject.url = window.location.href
    window.dataObject.event.push({
      ...eventData,
      page: eventData.page || window.location.pathname,
      url: eventData.url || window.location.href
    })
  }
}

export function trackQueryParam(paramName) {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search.slice(1))

  params.append(paramName, 'true')

  const href = window.location.origin + window.location.pathname + `?${params.toString()}`

  trackEvent({
    name: 'screenLoad',
    time: Date(),
    page: window.location.pathname + `?${params.toString()}`,
    url: href
  })

  if (window.dataObject) {
    window.dataObject.page = href
  }
}

export function untrackQueryParam(paramName) {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search.slice(1))
  if (!params.has(paramName)) return

  params.delete(paramName)

  const href = window.location.origin + window.location.pathname + `?${params.toString()}`

  trackEvent({
    name: 'screenLoad',
    time: Date(),
    page: window.location.pathname + `?${params.toString()}`,
    url: href
  })

  if (window.dataObject) {
    window.dataObject.page = href
  }
}

export function initGlassroom(w, d, s, l, i) {
  w[l] = w[l] || []
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
  var f = d.getElementsByTagName(s)[0]
  var j = d.createElement(s)
  var dl = l !== 'dataLayer' ? '&l=' + l : ''
  j.async = true
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
  f.parentNode.insertBefore(j, f)
}

export function initImpact(a, b, c, d, e, f, g) {
  const meow = function () {
    ;(e[c].a = e[c].a || []).push(arguments)
  }
  e['ire_o'] = c
  e[c] = e[c] || meow
  f = d.createElement(b)
  g = d.getElementsByTagName(b)[0]
  f.async = 1
  f.src = a
  g.parentNode.insertBefore(f, g)
}

export function getSessionID() {
  if (window.sessionStorage.sid) return window.sessionStorage.sid
  const sid = Math.random().toString(36).substr(2, 9)
  window.sessionStorage.sid = sid
}
